import { sectionBorderColor } from "@common/components/dotLegalSection/DotLegalSection";
import DotLegalCollapse from "../../../common/components/dotLegalCollapse/DotLegalCollapse";
import { useTranslation } from "@localization/useTranslation.ts";
import useTaskRelationsBoxHooks from "./TaskRelationsBox.hooks";
import { PurpleLockIcon } from "@common/icons.tsx";
import { EntityType } from "@common/Common.types.ts";
import { DotLegalHeader } from "@dotlegal/dotlegal-ui-components";
import React from "react";
import RelationsList from "./RelationsList.tsx";
import { usePlanContext } from "../../../auth/planProvider/PlanProvider.tsx";
import { getEntityTypeIcon } from "@common/components/entityTypeIcon/entityTypeIcon.tsx";
import { useRelationHook } from "@common/hooks/Relations.hooks.ts";

export interface ITaskRelationsBox {
    taskId: string;
    canEdit: boolean;
    annualWheelActivityId?: string;
}

export function getIcon(type: EntityType) {
    return getEntityTypeIcon(type);
}

function TaskRelationsBox(props: ITaskRelationsBox) {
    const { translateString } = useTranslation();
    const { expanded, setExpanded, data, removeRelation, refetch, parentActivityRelations } = useTaskRelationsBoxHooks(props);
    const { platformFeatures } = usePlanContext();
    const { onItemSelected } = useRelationHook(props.taskId, EntityType.Task, refetch);

    const hasParentActivityRelations = (parentActivityRelations?.length ?? 0) > 0;

    return (
        <>
            {props.canEdit || (data?.length ?? 0) > 0 || hasParentActivityRelations ? (
                <DotLegalCollapse
                    isExpanded={expanded}
                    onExpandClick={() => {
                        if (platformFeatures.canAccessRelationsBetweenEntities) {
                            if (expanded) {
                                setExpanded(false);
                            } else {
                                setExpanded(true);
                            }
                        }
                    }}
                    collapseIcon={
                        platformFeatures.canAccessRelationsBetweenEntities
                            ? undefined
                            : { icon: PurpleLockIcon, iconHoverText: translateString("upgradePrivacyPlanToday"), href: undefined, replaceIcon: true }
                    }
                    collapseName={translateString("relations")}
                    persistCollapseName
                    leftAlign
                    sx={{
                        marginTop: 2,
                        borderWidth: "1px",
                        borderColor: sectionBorderColor,
                        "&.MuiCollapse-root": {
                            backgroundColor: "white",
                        },
                    }}
                    isCollapseNameBold
                    arrowFontSize={28}
                >
                    <>
                        <RelationsList
                            data={data}
                            onRemoveRelation={props.canEdit ? removeRelation : undefined}
                            onRelationAdded={props.canEdit ? (relation) => onItemSelected(relation.entityId, relation.entityType) : undefined}
                        />
                        {hasParentActivityRelations && (
                            <>
                                <DotLegalHeader marginTop={1.5} headerStyle="small">
                                    {translateString("activityRelations")}
                                </DotLegalHeader>
                                <RelationsList data={parentActivityRelations} />
                            </>
                        )}
                    </>
                </DotLegalCollapse>
            ) : undefined}
        </>
    );
}

export default TaskRelationsBox;
